import { types } from "../../types/types";
import { startAlerta } from "../ui/alertas";
import { handleErrorApi } from "../../helpers/randoms";
import TurnosService from "../../services/TurnosService";
import { finishSpinner, startSpinner } from "../ui/spinner";
import CosegurosService from '../../services/CosegurosService';

export const getTurnosCtaCtePorGrupo = (idGrupoFamiliar) => async (dispatch) => {
  try {
    dispatch(startSpinner());
    const response = await TurnosService.getTurnosCtaCtePorGrupo(idGrupoFamiliar);
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.ctaCteGetTurnosSaldoSuccess,
        payload: body,
      });
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch({ type: types.ctaCteGetTurnosSaldoError });
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al traer los turnos de la Cta. Cte.",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const getTurnosCtaCte = (idAfiliado, nroDocumento, idObraSocial, showDisplay) => async (dispatch) => {
  try {
    dispatch(startSpinner());
    const response = await TurnosService.getTurnosCtaCte(idAfiliado, nroDocumento, idObraSocial);
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.ctaCteGetTurnosSuccess,
        payload: body,
      });
      showDisplay&& showDisplay();
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch({ type: types.ctaCteGetTurnosError });
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al traer los turnos de la Cta. Cte.",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const getValorizacionTurno = (idAgenda, idObraSocial, externo) => async (dispatch) => {
  try {
    dispatch(startSpinner());
    const response = !externo
      ? await CosegurosService.getValorizacionesCtaCte(idAgenda)
      : await CosegurosService.getValorizacionesCtaCteExterno(idAgenda, idObraSocial);
    const body = await response.json();
    if (response.ok) {      
      dispatch({
        type: types.ctaCteGetTurnoValorizacionSuccess,
        payload: body,
      });
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch({ type: types.ctaCteGetTurnoValorizacionError });
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al obtener el valor del turno.",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const getDetalleComprobanteCtaCte =
  (data, setDisplayDetalleComprobante) => async (dispatch) => {
    try {
      const response = await TurnosService.getDetalleComprobanteCtaCte(data);
      const body = await response.json();
      if (response.ok) {
        dispatch({
          type: types.ctaCteGetDetalleComprobanteSuccess,
          payload: body,
        });
        setDisplayDetalleComprobante(true);
      } else {
        throw body;
      }
    } catch (error) {
      dispatch({ type: types.ctaCteGetDetalleComprobanteError });
      handleErrorApi(
        dispatch,
        error,
        "Error al traer el detalle del comprobante.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };

export const postPagoTurnoCtaCte =
  (data, displayModalPago, displayModalConfirmPago) => async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await TurnosService.postPagoTurnoCtaCte(data);
      const body = await response.json();
      if (response.ok) {
        startAlerta("Pago realizado con éxito", "success", "Pago realizado");
        dispatch(getTurnosCtaCte(data.idAfiliado));
        displayModalPago(false);
        displayModalConfirmPago(false);
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al registrar el pago de cta cte.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };

export const postPagoTurnoACuenta =
  (data, displayModalPago, displayModalConfirmPago) => async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await TurnosService.postPagoTurnoACuenta(data);
      const body = await response.json();
      if (response.ok) {
        startAlerta("Pago realizado con éxito", "success", "Pago realizado");
        dispatch(getTurnosCtaCte(data.idAfiliado));
        displayModalPago(false);
        displayModalConfirmPago(false);
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al registrar el pago de cta cte.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };  